enum SearchLanguage {
    English = 'english',
    Hebrew = 'hebrew',
    Greek = 'greek'
}

export default SearchLanguage;
